import './NotificationGlyph.scss';

/**
 * The glyph that says what kind of notification a row is — a tick for good
 * news, a cross for bad, an arrow for a step forward, a dot for the rest.
 *
 * Shared because the bell's dropdown and the notifications page draw the same
 * set, off the same `tone` that `notificationsApi` derives. It is only the
 * glyph: the tinted square around it belongs to whichever list is drawing it,
 * since the two sit on different surfaces.
 *
 * Anything it doesn't recognise falls to the dot, which is also what the page's
 * "Unread" counter wants — a mark with no news in it.
 */
export default function NotificationGlyph({ tone }) {
  if (tone === 'success') {
    return (
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
  }

  if (tone === 'danger') {
    return (
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    );
  }

  if (tone === 'info') {
    return (
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <line x1="12" y1="19" x2="12" y2="5" />
        <polyline points="5 12 12 5 19 12" />
      </svg>
    );
  }

  return <span className="notif-glyph-dot" />;
}
